/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import * as $ from "jquery";
import {UiField} from "./UiField";
import {UiFieldEditingMode} from "../../generated/UiFieldEditingMode";
import {UiMultiLineTextFieldConfig} from "../../generated/UiMultiLineTextFieldConfig";
import {TeamAppsUiContext} from "../TeamAppsUiContext";
import * as md5 from "md5";
import {UiPasswordFieldConfig, UiPasswordFieldSubCommandHandler, UiPasswordFieldSubEventSource} from "../../generated/UiPasswordFieldConfig";
import {keyCodes} from "trivial-components";
import {TeamAppsUiComponentRegistry} from "../TeamAppsUiComponentRegistry";
import {SubEventFactory} from "../../generated/SubEventFactory";
import {TeamAppsEvent} from "../util/TeamAppsEvent";
import {UiTextInputHandlingField_TextInputSubEvent} from "../../generated/UiTextInputHandlingFieldConfig";
import {UiTextField} from "./UiTextField";
import {UiTextFieldConfig} from "../../generated/UiTextFieldConfig";

/**
 * @author Yann Massard (yamass@gmail.com)
 */

export class UiPasswordField extends UiTextField<UiPasswordFieldConfig> implements UiPasswordFieldSubEventSource, UiPasswordFieldSubCommandHandler {
	private salt: string;
	private sendValueAsMd5: boolean;


	protected initialize(config: UiPasswordFieldConfig, targetElement: Element, context: TeamAppsUiContext): void {
		this.salt = config.salt;
		this.sendValueAsMd5 = config.sendValueAsMd5;
		super.initialize(config, targetElement, context);
		this.$field.attr("type", "password");
	}

	setSalt(salt: string): void {
		this.salt = salt;
	}

	setSendValueAsMd5(sendValueAsMd5: boolean): void {
		this.sendValueAsMd5 = sendValueAsMd5;
	}

	getTransientValue(): string {
		return this.calculateValueString(this.$field.val());
	}

	private calculateValueString(value: any) {
		let valueString: string;
		if (this.sendValueAsMd5) {
			if (this.salt) {
				valueString = md5(this.salt + md5(value));
			} else {
				valueString = md5(value);
			}
		} else {
			valueString = value;
		}
		return valueString;
	}
}

TeamAppsUiComponentRegistry.registerFieldClass("UiPasswordField", UiPasswordField);